<template>
  <div class="row profile-user__row-owl">
    <div class="col">
      <div v-if="show">
        <div class="profile-gallery-nav">
          <div
            class="profile-gallery-nav__arrow profile-gallery-nav__arrow--left"
            @click="$refs.prev.click()"
          ></div>
          <div
            class="profile-gallery-nav__arrow profile-gallery-nav__arrow--right"
            @click="$refs.next.click()"
          ></div>
        </div>
        <carousel
          class="profile-owl-carousel"
          :nav="false"
          :loop="false"
          :dots="true"
          :margin="10"
          :responsive="responsive"
        >
          <template v-slot:prev><span hidden ref="prev" class="prev"></span></template>
          <template v-slot:next><span hidden ref="next" class="next"></span></template>

          <div v-if="imagesUnBlurred.length === 0 && imagesBlurred.length === 0" class="item">
            <div class="profile-card">
              <div class="profile-owl-carousel__img show profile-card__image" v-bind:style="{ 'background-image': 'url(' + profileAvatarUrl + '?p=small) ' }">
                <div class="rightbottom__corner">
                  <div class="profile-card__card-symbol">
                    <p>{{ age }}</p>
                    <div class="order-1">
                      <GenderIcon :gender="gender" />
                    </div>
                  </div>
                </div>
                <div class="lefttop__corner">
                  <div class="profile-card__card-symbol">
                    <p>{{ age }}</p>
                    <div class="order-1">
                      <GenderIcon :gender="gender" />
                    </div>
                    <HeartWithTooltip variant="secondary" v-if="hasHeart"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-for="(media, key) in allMedia" class="item" :class="{ 'my-blurred': own && media.price > 0 }">
            <span v-if="media.is_blurred" @click="buyMediaDebounced(media)" v-click-of-drag:[media]="buyMediaDebounced">
              <div class="profile-card">
                <div
                  class="profile-owl-carousel__img blurred profile-card__image"
                  v-bind:style="{ 'background-image': 'url(' + media.url + '?p=small&type=blurred) ' }"
                >
                  <div class="rightbottom__corner">
                    <div class="image-price">
                      {{ media.price }}
                      <i class="demo-icon icon-n-lova-coins"></i>
                    </div>
                  </div>
                  <div class="profile-card__middle">
                    <button class="button button--tight button__outline button__outline--white-hov-white">
                      {{ trans.get('pages:chat.img_click_to_view') }}
                    </button>
                  </div>
                </div>
              </div>
            </span>
            <div
              v-else
              class="profile-card"
              :class="{ 'free-image-popup': user }"
              :data-mfp-src="media.url + '?p=big'"
              :data-mfp-id="media.id"
              title=""
              @click="openMagnificPopup(media.id)"
            >
              <div
                class="profile-owl-carousel__img show profile-card__image"
                v-bind:style="{ 'background-image': 'url(' + media.url + '?p=large) ' }"
              >
                <div class="rightbottom__corner">
                  <div class="profile-card__card-symbol">
                    <p>{{ age }}</p>
                    <div class="order-1">
                      <GenderIcon :gender="gender" />
                    </div>
                  </div>
                </div>
                <div class="lefttop__corner">
                  <div class="profile-card__card-symbol">
                    <p>{{ age }}</p>
                    <div class="order-1">
                      <GenderIcon :gender="gender" />
                    </div>
                    <HeartWithTooltip variant="secondary" v-if="hasHeart"/>
                  </div>
                </div>
                <div
                  v-if="!own && user"
                  class="righttop__corner js-photo-violation-modal"
                  @click="photoViolationAction(media.id)"
                >
                  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </div>
                <div class="leftbottom__corner">
                  <i class="icon-demo icon-n-lova-coins" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </carousel>
      </div>
      <div v-else>
        <div class="profile-owl-carousel d-md-flex pl-1 pt-2">
          <div v-for="(index, media) in [1, 2, 3]" class="item" :class="{ 'd-none d-md-block': index > 1 }">
            <div class="profile-card ml-md-1 mr-md-3">
              <div class="profile-owl-carousel__img show profile-card__image"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PhotoReportModal></PhotoReportModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import carousel from '../../modules/OwlCarousel';
import PhotoReportModal from './PhotoReportModal';
import GenderIcon from '../Ui/GenderIcon.vue';
import HeartWithTooltip from './HeartWithTooltip.vue';

export default {
  name: 'GalleryComponent',
  components: { GenderIcon, PhotoReportModal, carousel, HeartWithTooltip },
  props: {
    profileId: null,
    age: null,
    profileAvatarUrl: null,
    hasHeart: null,
    gender: null,
  },
  data() {
    return {
      responsive: {
        0: { items: 1 },
        769: { items: 3 },
        1000: { items: 4 },
        1400: { items: 5 },
        1800: { items: 7 },
        2000: { items: 7 },
        3000: { items: 7 },
      },
      show: false,
      imagesUnBlurred: [],
      imagesBlurred: [],
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    own: function () {
      return this.user && this.profileId === this.user.id;
    },
    allMedia: function () {
      return this.imagesUnBlurred.concat(this.imagesBlurred);
    },
  },
  methods: {
    fetchData: function () {
      let vm = this;
      axios
        .get(zRoute('ajax.profiles.media.index', this.profileId))
        .then((response) => {
          vm.show = false;
          let media = response.data.data;

          vm.imagesUnBlurred = media.filter((m) => !m.is_blurred);
          vm.imagesBlurred = media.filter((m) => m.is_blurred);

          this.$nextTick(() => {
            vm.show = true;
          });
        });
    },
    refreshImage: function (media) {
      let index = this.imagesBlurred.findIndex((x) => {
        return x.id === media.id;
      });

      if (index !== -1) {
        this.imagesBlurred[index].url = media.url;
        this.imagesBlurred[index].is_blurred = media.is_blurred;
      }
    },
    buyMediaDebounced: _.debounce(function (media) {
      this.buyMedia(media);
    }, 50),
    buyMedia(media) {
      this.$eventHub.$emit('BuyMediaModalOpen', media);
    },
    openMagnificPopup(mediaId) {
      setTimeout(() => {
        window.openMagnificPopup(mediaId);
      }, 10);
    },
    photoViolationAction(mediaId) {
      window.globals.enableImageMagnificPopup = false;
      this.$eventHub.$emit('PhotoReportModalOpen', mediaId);
      setTimeout(function () {
        window.globals.enableImageMagnificPopup = true;
      }, 100);
    },
  },
  mounted() {
    this.fetchData();

    this.$eventHub.$on('FreshMedia', (media) => {
      this.refreshImage(media);
    });
  },
};
</script>

<style scoped lang="scss">
.profile-heart-icon-wrapper {
  order: 2;

  ::v-deep svg {
    color: white;
    display: block;
    width: auto;
    height: 15px;
  }
}
</style>
